namespace TabAurous.Retail {
    export interface POSSalesForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        PartyId: Serenity.IntegerEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        TaxId: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        GSTState: Serenity.StringEditor;
        MF: Serenity.DecimalEditor;
        ImageName: Serenity.ImageUploadEditor;
        ItemDetails: POSSalesItemsEditor;
        GiftDetails: POSSalesGiftVoucherEditor;
        PromoDetails: PosSalesPromoEditor;
        TaxDetails: POSSalesTaxEditor;
        ReceiptDetails: POSSalesReceiptEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: AmountEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Receipt: Serenity.DecimalEditor;
        BalanceAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class POSSalesForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSSales';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSSalesForm.init)  {
                POSSalesForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.ServiceLookupEditor;
                var w6 = s.TextAreaEditor;
                var w7 = s.LookupEditor;
                var w8 = s.DecimalEditor;
                var w9 = s.ImageUploadEditor;
                var w10 = POSSalesItemsEditor;
                var w11 = POSSalesGiftVoucherEditor;
                var w12 = PosSalesPromoEditor;
                var w13 = POSSalesTaxEditor;
                var w14 = POSSalesReceiptEditor;
                var w15 = AmountEditor;

                Q.initFormType(POSSalesForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'AutoPosting', w3,
                    'VoucherTypeId', w4,
                    'POSCustomerId', w5,
                    'CustomerName', w2,
                    'Address', w6,
                    'PartyId', w4,
                    'Mobile', w4,
                    'PanNumber', w2,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'TaxId', w2,
                    'CurrencyId', w7,
                    'ExchRate', w8,
                    'EmployeeId', w7,
                    'UserId', w7,
                    'GSTState', w2,
                    'MF', w8,
                    'ImageName', w9,
                    'ItemDetails', w10,
                    'GiftDetails', w11,
                    'PromoDetails', w12,
                    'TaxDetails', w13,
                    'ReceiptDetails', w14,
                    'Pieces', w4,
                    'Weight', w8,
                    'NetWeight', w8,
                    'NetAmount', w8,
                    'TaxAmount', w15,
                    'Discount', w8,
                    'AdditionalCharges', w8,
                    'RoundOff', w8,
                    'GrossAmount', w8,
                    'Receipt', w8,
                    'BalanceAmount', w8,
                    'Remark', w6,
                    'ShipAddressId', w4,
                    'FinancialYearId', w4,
                    'CompanyId', w4
                ]);
            }
        }
    }
}
